<template>
  <national-local-location-selector :value="value"
                                    :local-option-label="i18n.t('member.events.location.virtual_with_location')"
                                    :local-option-hint="i18n.t('member.events.location.virtual_with_location_hint')"
                                    :national-option-label="i18n.t('member.events.location.virtual_no_location')"
                                    :national-option-hint="i18n.t('member.events.location.virtual_no_location_hint')"
                                    @changed="changed"
                                    @location-kind-changed="locationKindChanged" />
</template>

<script>
import NationalLocalLocationSelector from '@/components/inputs/national-local-location-selector'

export default {
  components: { NationalLocalLocationSelector },

  props: {
    value: {
      type: Object,
      required: false
    }
  },

  emits: ['changed', 'location-kind-changed'],

  methods: {
    changed(newValue) {
      this.$emit('changed', newValue)
    },

    locationKindChanged(newValue) {
      this.$emit('location-kind-changed', newValue)
    }
  }
}
</script>
